import React, { FC, useEffect, useState, memo } from 'react';
import {
  getTimeDifference,
  getTimeWithTimeZone,
} from 'utils/helpers/momentTime';
import { Draggable } from 'react-beautiful-dnd';
import { IEvents } from 'types';
import moment from 'moment';
import Delete from 'style/imgs/icons/delete-icon.svg';
import DragIcon from './dragIcon';
import styles from '../index.module.scss';

const PX_IN_MIN = 1.33;

interface IEventProps {
  errortimeEvents?: IEvents[];
  anetaPackSchedule?: IEvents[];
  day: moment.Moment;
  event: IEvents;
  idx: number;
  diff: number;
  dndId: number;
  removeEventFromSchedule?: (eventId: number) => void;
}
const Event: FC<IEventProps> = ({
  event,
  idx,
  day,
  diff,
  dndId,
  removeEventFromSchedule,
  errortimeEvents,
  anetaPackSchedule,
}) => {
  const diffInTime = getTimeDifference(
    moment(event.startTime, 'YYYY-MM-DD HH:mm'),
    event.startTimeStr || '00:00',
    event.endTimeStr || '00:00',
    moment(event.endTime, 'YYYY-MM-DD HH:mm')
  );
  const [eventHeight, setEventHeight] = useState<number>(
    diffInTime * PX_IN_MIN
  );

  useEffect(() => {
    const height = diffInTime * PX_IN_MIN;
    setEventHeight(height);
  }, [diffInTime, day, event]);

  const getEventColor = () => {
    let eventColor;
    if (dndId === 1) {
      eventColor = '#10C9BE';
      anetaPackSchedule?.forEach((el) => {
        if (el.id === event.id) {
          eventColor = '#168abc';
        }
      });
    }
    if (dndId === 2) {
      eventColor = '#168abc';
    }
    errortimeEvents?.forEach((el) => {
      if (el.id === event.id) {
        eventColor = '#e44575';
      }
    });
    return eventColor;
  };

  return (
    <Draggable
      key={event.id}
      draggableId={`${event.id}_${diffInTime}`}
      index={idx}
    >
      {(provided) => {
        return (
          <div
            className={styles.cell}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div
              style={{
                background: `${getEventColor()}`,
                height: eventHeight,
                top: `${PX_IN_MIN * diff}px`,
              }}
              className={styles.eventView}
            >
              <div
                style={
                  getEventColor() === '#e44575' ? { background: '#FFF5F9' } : {}
                }
                className={styles.eventBackground}
              >
                <div>
                  <div>
                    <span>{`${event.subject} `}</span>
                    {event.link && <a href={event.link}>{event.link}</a>}
                  </div>
                  <span>{`${moment(
                    getTimeWithTimeZone(event.startTimeStr || '00:00', 'HH:mm'),
                    'HH:mm'
                  ).format('LT')} - ${moment(
                    getTimeWithTimeZone(event.endTimeStr || '00:00', 'HH:mm'),
                    'HH:mm'
                  ).format('LT')}`}</span>
                </div>
                {removeEventFromSchedule && (
                  <div className={styles.deleteBlock}>
                    <button
                      type="button"
                      style={
                        getEventColor() === '#e44575'
                          ? { background: '#FFF5F9' }
                          : {}
                      }
                      onClick={(e) => {
                        e.stopPropagation();
                        removeEventFromSchedule(event.id || 0);
                      }}
                      className={styles.trash}
                    >
                      <img src={Delete} alt="delete event" />
                    </button>
                  </div>
                )}
              </div>
              <div
                className={styles.icon}
                style={{ top: `${(PX_IN_MIN / 2) * diff}px` }}
              >
                <DragIcon color="#fff" width={20} height={20} />
              </div>
            </div>
          </div>
        );
      }}
    </Draggable>
  );
};

export default memo(Event);
